import { useCallback } from "react";

const useStorage = (storage: Storage | undefined) => {
  const getStorage = useCallback(
    <T>(key: string, defaultValue: T): T => {
      if (!storage) {
        return defaultValue;
      }
      const storedValue = storage.getItem(key);
      if (!storedValue) {
        return defaultValue;
      }
      try {
        return JSON.parse(storedValue) as T;
      } catch (error) {
        console.error(`Error parsing storage key "${key}":`, error);
        return defaultValue;
      }
    },
    [storage]
  );

  const setStorage = useCallback(
    <T>(key: string, value: T): void => {
      if (!storage) return;
      try {
        storage.setItem(key, JSON.stringify(value));
      } catch (error) {
        console.error(`Error setting storage key "${key}":`, error);
      }
    },
    [storage]
  );

  const removeStorage = useCallback(
    (key: string): void => {
      if (!storage) return;
      storage.removeItem(key);
    },
    [storage]
  );

  return { getStorage, setStorage, removeStorage };
};

export function useLocalStorage() {
  const storage = typeof window !== "undefined" ? window.localStorage : undefined;
  return useStorage(storage);
}

export function useSessionStorage() {
  const storage = typeof window !== "undefined" ? window.sessionStorage : undefined;
  return useStorage(storage);
}
